<template>
    <div id="app" v-cloak style="height: 100%" :class="{'whiteBg': $route.name == 'feedback'}" v-if="authentical">
        <keep-alive :exclude="['feedback', 'replyList', 'sendMail']">
            <router-view/>
        </keep-alive>
        <help-nav v-if="renderFixedBar"></help-nav>
        <loading></loading>
        <nio-toast></nio-toast>
        <uimask></uimask>
        <garbage-qrcode></garbage-qrcode>
        <!-- <version-update @viewed="actionRemove" v-if="showing && renderVersionUpdate"></version-update> -->
    </div>
</template>

<script>
    import { COMMON } from '@/api'
    import HelpNav from '@/components/navigation'
    import loading from '@/components/loading'
    import uimask from '@/components/uimask'
    import nioToast from '@/components/toast'
    import garbageQrcode from '@/components/garbageQrcode'
    import versionUpdate from '@/components/versionUpdate'

    export default {
        name: 'app',
        components: {
            loading, uimask, HelpNav, nioToast, garbageQrcode, versionUpdate
        },
        computed: {
            renderFixedBar() {
                return this.$store.getters._ShowFixedBar
            },
            renderVersionUpdate() {
                return !localStorage.VersionUpdate_1024
                // return false
            },
            authentical() {  // 身份信息校验完成
                return this.$store.getters._Auth
            }
        },
        data() {
            return {
                showing: true
            }
        },
        created() {
            // // 调取过鉴权Url 不再调用
            // // 后期可能需要去掉此判断 Debug那边会迭代更新鉴权信息有效期
            // if (localStorage.Help_Debug_AuthAppId !== undefined && localStorage.Help_Debug_AuthSign !== undefined) return
            // COMMON.DebugAuthUrl().then( (res) => {
            //     if (res && res.Data) {
            //         localStorage.Help_Debug_AuthAppId = res.Data.AppId
            //         localStorage.Help_Debug_AuthSign = res.Data.Sign
            //     }
            // })
        },
        methods: {
            actionRemove() {
                this.showing = false
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    @import "../static/scss/index.scss";
    #app{
        // overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .whiteBg {
        background: #ffffff;
    }

    [v-cloak] {
        display: none;
    }
    .pswp__counter {
        left: 50%;
        transform: translateX(-50%);
    }
    .pswp__button{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue